var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-badge"},[_c('MaterialIcon',{attrs:{"iconName":_vm.badge.iconName}}),_vm._v(" "+_vm._s(_vm.badge.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }